/**
 * @fileoverview POST handler for the "/engagement/segments/star" and
 * "/engagement/segments/unstar" endpoints
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsStarCacheKeys } from "./constants";
import type { PostEngagementSegmentsStarProps, EngagementSegmentsStarUpdateResult } from "./types";

export const postEngagementSegmentsStar = reactQueryMutationAdapter(
  engagementSegmentsStarCacheKeys,
  (props: PostEngagementSegmentsStarProps): Promise<EngagementSegmentsStarUpdateResult> => {
    return fetch(`/engagement/segments/star`, "POST", props);
  }
);

export const postEngagementSegmentsUnstar = reactQueryMutationAdapter(
  engagementSegmentsStarCacheKeys,
  (props: PostEngagementSegmentsStarProps): Promise<EngagementSegmentsStarUpdateResult> => {
    return fetch(`/engagement/segments/unstar`, "POST", props);
  }
);
